import React, { Component } from "react";
// import domain from '.././../../../domain'
// import axios from 'axios'
import moment from "moment";
import { Link } from "react-router-dom";
import { Button } from "mdbreact";
import SessionFeedbackSummary from "./SessionWiseFeedbackSummary";
function dateFormatter(cell) {
  return moment(cell).tz("Asia/Kolkata").format("DD/MM/YYYY");
}
export default class ViewScheduleTable extends Component {
  render() {
    let sessions;
    if (this.props.session_details && this.props.button_date) {
      sessions = this.props.session_details.map((session, key) => {
        let session_date = moment(session.session_date).format("DD-MM-YYYY");

        let buttons_date = moment(this.props.button_date).format("DD-MM-YYYY");
        console.log(session_date);
        console.log(buttons_date);
        if (session_date === buttons_date) {
          //   let start_time=moment(session.start_time,"h:mm a").format("HH:mm a")
          //   let end_time=moment(session.end_time,"h:mm a").format("HH:mm a")
          // //   let time=start_time + "-"+end_time
          return (
            <tr key={key}>
              {/* {console.log(course.course_id)} */}
              <th scope="row" style={{ textAlign: "right" }}>
                {key + 1}
              </th>
              <td>{session.lecturer_name}</td>
              <td>{session.title}</td>
              <td>{dateFormatter(session.session_date)}</td>

              <td>{session.start_time}</td>
              <td>{session.end_time}</td>
              <td>
                <Link
                  to={`/session-wise-feedback-report/${session.course_session_id}/${this.props.course_name}`}
                >
                  {" "}
                  <Button size="sm">Feedback</Button>
                </Link>
              </td>
              <td>
                {" "}
                <SessionFeedbackSummary
                  course_id={this.props.course_id}
                  session={session.course_session_id}
                  session_title={session.title}
                />
              </td>
            </tr>
          );
        }
        return true;
      });
    }
    return <tbody>{sessions}</tbody>;
  }
}
